import { useTranslation } from 'react-i18next';
import { signOutAndReload } from '../../lib/session';
import { Box, Button, Card, CardContent, Link, Stack, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { authTheme } from './auth-theme';
import { useFunnelLanguage } from './use-funnel-language';
import { TeachMark } from '../../components/TeachMark';

const EMERALD = '#0f766e';
const ACCENT = '#10b981';

/**
 * Shown when an authenticated user has no seminary membership
 * (e.g. a fresh Google sign-in for an email not linked to any tenant).
 * No auto-provisioning — the user signs out or asks to register a seminary.
 */
export function NoAccessPage() {
  const { t } = useTranslation('auth');
  useFunnelLanguage(); // browser-detect language on first visit

  async function handleSignOut() {
    await signOutAndReload();
  }

  return (
    <ThemeProvider theme={authTheme}>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
          background: 'linear-gradient(135deg, #f6f4ee 0%, #eaf3ef 55%, #e2efe9 100%)',
        }}
      >
        <Card
          sx={{
            width: 460,
            maxWidth: '100%',
            borderRadius: 4,
            border: '1px solid rgba(19,32,29,0.08)',
            boxShadow: '0 24px 60px -24px rgba(19,32,29,0.28)',
            background: '#fffdf8',
          }}
        >
          <CardContent sx={{ p: { xs: 3, sm: 4.5 } }}>
            <Stack alignItems="center" spacing={2} textAlign="center">
              <TeachMark size={50} title="Teach by DosFilos" />
              <Typography variant="h6" fontWeight={800} sx={{ color: '#13201d' }}>
                {t('noAccess.title')}
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(19,32,29,0.6)', maxWidth: 360 }}>
                {t('noAccess.message')}
              </Typography>
              <Button
                onClick={handleSignOut}
                variant="contained"
                size="large"
                sx={{
                  mt: 1,
                  px: 4,
                  py: 1.1,
                  fontWeight: 700,
                  borderRadius: 2.5,
                  textTransform: 'none',
                  background: `linear-gradient(135deg, ${EMERALD} 0%, ${ACCENT} 100%)`,
                  '&:hover': { background: `linear-gradient(135deg, #0b5d56 0%, ${EMERALD} 100%)` },
                }}
              >
                {t('noAccess.signOut')}
              </Button>
              <Link
                href="/registro"
                sx={{ color: EMERALD, fontSize: 14, textDecorationColor: `${EMERALD}66` }}
              >
                {t('noAccess.registerCta')}
              </Link>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </ThemeProvider>
  );
}
